import type { DictionaryBookItemFragment } from '../../../dictionary/dictionary.graphql.generated';
import { isSpanishSupportEnabled } from 'approot/lesson/lesson-spanish-switch.utils';
import { TabOption } from 'approot/shared/tabs/tabs.constants';
import { LANGUAGE_CODE_EN_US, LANGUAGE_CODE_ES_US } from 'global/constants';

export function getVocabularyViewTabOptions({
  definition,
}: {
  definition: DictionaryBookItemFragment;
}) {
  const isSpanishTabEnabled = isSpanishSupportEnabled();

  const options: TabOption[] = [
    {
      label: definition.word,
      value: LANGUAGE_CODE_EN_US,
    },
  ];
  definition.aiDefinitions?.wordsTranslation?.forEach(item => {
    if (item.language && item.language !== LANGUAGE_CODE_EN_US) {
      if (item.language === LANGUAGE_CODE_ES_US && !isSpanishTabEnabled) {
        return;
      }
      options.push({
        label: item.word,
        value: item.language,
        language: item.language,
      });
    }
  });
  return options;
}
